import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

export function TermsOfServiceCS() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gradient-to-br from-purple-100 to-indigo-100">
      <div className="max-w-4xl mx-auto px-4 py-8">
        <button
          onClick={() => navigate('/')}
          className="inline-flex items-center text-indigo-600 hover:text-indigo-700 mb-6 transition-colors duration-200"
        >
          <ArrowLeft className="mr-2 h-5 w-5" />
          Zpět do aplikace
        </button>

        <article className="bg-white rounded-lg shadow-xl p-8">
          <h1 className="text-3xl font-bold text-gray-900 mb-8">Obchodní podmínky</h1>

          <div className="space-y-6 text-gray-700">
            <p className="text-sm text-gray-500">
              Poslední aktualizace: {new Date().toLocaleDateString('cs-CZ')}
            </p>

            <section>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">1. Informace o společnosti</h2>
              <div className="space-y-3">
                <p className="leading-relaxed">
                  Simple Stickers je provozováno společností <span className="font-semibold">Puretech s.r.o.</span>,
                  <span className="font-semibold">společností s ručením omezeným</span> založenou podle práva <span className="font-semibold">České republiky</span>.
                </p>
                <div className="bg-gray-50 p-4 rounded-lg">
                  <p className="text-sm font-medium text-gray-700 mb-2">Údaje o společnosti:</p>
                  <ul className="text-sm text-gray-600 space-y-1">
                    <li><strong>IČO:</strong> 05503795</li>
                    <li><strong>Status DPH:</strong> Neplátce</li>
                    <li><strong>Adresa sídla:</strong> Heydukova 1035, 54401 Dvůr Králové nad Labem, Česká republika</li>
                    <li><strong>E-mail:</strong> support@simplestickers.app</li>
                    <li><strong>Web:</strong> <a href="https://www.simplestickers.app" target="_blank" rel="noopener noreferrer" className="text-indigo-600 hover:text-indigo-800 hover:underline">www.simplestickers.app</a></li>
                  </ul>
                </div>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">2. Přijetí podmínek</h2>
              <p className="leading-relaxed">
                Přístupem a používáním Simple Stickers ("Služba") přijímáte a souhlasíte s tím, že budete vázáni podmínkami této smlouvy. Pokud s výše uvedeným nesouhlasíte, tuto službu nepoužívejte.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">3. Popis služby</h2>
              <p className="leading-relaxed">
                Simple Stickers je aplikace pro správu úkolů a projektů, která uživatelům poskytuje nástroje pro organizaci poznámek pomocí Kanban boardu. Služba zahrnuje bezplatnou i prémiovou úroveň s různými funkcemi a limity použití.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">4. Uživatelské účty</h2>
              <div className="space-y-3">
                <p className="leading-relaxed">
                  Jste odpovědní za zachování důvěrnosti vašeho účtu a hesla a za omezení přístupu k vašemu počítači. Souhlasíte s tím, že přijímáte odpovědnost za všechny aktivity, které se vyskytnou pod vaším účtem nebo heslem.
                </p>
                <p className="leading-relaxed">
                  Při vytváření účtu musíte poskytnout přesné a úplné informace a tyto informace udržovat aktuální.
                </p>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">5. Předplatné a platební podmínky</h2>
              <div className="space-y-3">
                <p className="leading-relaxed">
                  <strong>Bezplatná úroveň:</strong> Zahrnuje přístup k základním funkcím s omezením počtu poznámek (50) a AI návrhů (10 denně).
                </p>
                <p className="leading-relaxed">
                  <strong>Prémiová úroveň:</strong> K dispozici za $48 ročně, zahrnuje zvýšené limity (1000 poznámek, 100 AI návrhů denně) a další funkce, jako je sdílení poznámek.
                </p>
                <p className="leading-relaxed">
                  Zpracování plateb zajišťuje Polar. Předplatné se automaticky obnovuje, pokud není zrušeno. Své předplatné můžete kdykoli zrušit v nastavení účtu.
                </p>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">6. Přijatelné použití</h2>
              <p className="leading-relaxed">
                Souhlasíte s tím, že službu nebudete používat k ukládání, přenosu nebo distribuci obsahu, který je nezákonný, škodlivý, výhružný, urážlivý, obtěžující, pomlouvačný, vulgární, obscénní nebo jinak nevhodný. Rovněž souhlasíte s tím, že nebudete zasahovat do služby nebo se pokoušet získat přístup k účtům jiných uživatelů.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">7. Ochrana soukromí a osobních údajů</h2>
              <div className="space-y-3">
                <p className="leading-relaxed">
                  Vaše soukromí je pro nás důležité. Podrobnosti o tom, jak shromažďujeme, používáme a chráníme vaše osobní údaje, naleznete v našich <a href="/privacy-policy" className="text-indigo-600 hover:text-indigo-800 hover:underline font-medium">Zásadách ochrany osobních údajů</a>.
                </p>
                <p className="leading-relaxed">
                  Používáním této služby souhlasíte také s našimi Zásadami ochrany osobních údajů a zpracováním vašich osobních údajů v souladu s GDPR a příslušnými zákony o ochraně údajů.
                </p>
                <p className="leading-relaxed">
                  Pro uplatnění vašich práv podle GDPR nebo pro dotazy týkající se ochrany údajů nás kontaktujte na <strong>support@simplestickers.app</strong>.
                </p>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">8. Dostupnost služby a podpora</h2>
              <div className="space-y-3">
                <p className="leading-relaxed">
                  <strong>Dostupnost služby:</strong> Usilujeme o maximální dostupnost služby a spolehlivý provoz. V případě neplánovaných výpadků pracujeme na jejich rychlém vyřešení. Službu poskytujeme "tak jak je", bez formálních záruk dostupnosti.
                </p>
                <p className="leading-relaxed">
                  <strong>Údržba:</strong> Pro zajištění bezpečnosti a stability můžeme průběžně provádět údržbu služby. Plánovanou údržbu se snažíme provádět v době s nízkou návštěvností a informujeme o ní předem, kdykoli je to možné. V naléhavých případech (např. bezpečnostní záplaty) může údržba proběhnout bez předchozího upozornění.
                </p>
                <p className="leading-relaxed">
                  <strong>Podpora:</strong> Nabízíme technickou podporu prostřednictvím e-mailu support@simplestickers.app. Snažíme se odpovídat co nejrychleji, nicméně konkrétní reakční doby nezaručujeme.
                </p>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">9. Zásady vrácení peněz</h2>
              <div className="space-y-3">
                <p className="leading-relaxed">
                  <strong>30denní záruka vrácení peněz:</strong> Pokud nejste spokojeni s prémiovým předplatným, můžete požádat o plné vrácení peněz do 30 dnů od prvního nákupu. Po 30 dnech jsou všechny platby konečné a nevratné.
                </p>
                <p className="leading-relaxed">
                  <strong>Chyby ve vyúčtování:</strong> Pokud se domníváte, že vám byla nesprávně účtována platba, kontaktujte nás na support@simplestickers.app do 30 dnů od účtování.
                </p>
                <p className="leading-relaxed">
                  <strong>Zpracování vrácení:</strong> Schválené refundace budou zpracovány do 10-14 pracovních dnů na původní platební metodu. Vyhrazujeme si právo schválit nebo zamítnout žádosti o vrácení peněz podle vlastního uvážení.
                </p>
                <p className="text-sm text-gray-600">
                  Poznámka: Zrušení předplatného automaticky nevede k vrácení peněz. Musíte výslovně požádat o vrácení peněz do 30denní lhůty.
                </p>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">10. Věková omezení a způsobilost</h2>
              <div className="space-y-3">
                <p className="leading-relaxed">
                  <strong>Minimální věk:</strong> K používání této služby musíte mít alespoň 16 let.
                </p>
                <p className="leading-relaxed">
                  <strong>Souhlas rodičů:</strong> Uživatelé mladší 18 let musí mít souhlas rodiče nebo opatrovníka k používání služby.
                </p>
                <p className="leading-relaxed">
                  <strong>Firemní uživatelé:</strong> Firemní účty vyžadují, aby uživatel měl pravomoc zavázat organizaci.
                </p>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">11. Rozhodné právo a jurisdikce</h2>
              <div className="space-y-3">
                <p className="leading-relaxed">
                  Tyto Podmínky se řídí a jsou vykládány v souladu s právem České republiky, bez ohledu na kolizní normy.
                </p>
                <p className="leading-relaxed">
                  Jakékoli spory vyplývající z těchto Podmínek nebo vašeho používání Služby budou podléhat výlučné jurisdikci soudů České republiky.
                </p>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">12. Moderování obsahu</h2>
              <div className="space-y-3">
                <p className="leading-relaxed">
                  Vyhrazujeme si právo odstranit, upravit nebo odmítnout zobrazení jakéhokoli obsahu, který porušuje tyto Podmínky nebo který považujeme za nevhodný, podle našeho výhradního uvážení.
                </p>
                <p className="leading-relaxed">
                  Pokud se domníváte, že obsah by měl být přezkoumán, kontaktujte nás na support@simplestickers.app.
                </p>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">13. Duševní vlastnictví</h2>
              <p className="leading-relaxed">
                Služba a její původní obsah, funkce a funkcionalita jsou vlastněny Simple Stickers a jsou chráněny mezinárodními zákony o autorských právech, ochranných známkách, patentech, obchodním tajemství a dalšími zákony o duševním vlastnictví.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">14. Omezení odpovědnosti</h2>
              <div className="space-y-3">
                <p className="leading-relaxed">
                  V maximálním rozsahu povoleném platným právem Simple Stickers neodpovídá za žádné nepřímé, náhodné, zvláštní, následné nebo exemplární škody, včetně mimo jiné ztráty zisku, dat, použití, dobré pověsti nebo jiných nehmotných ztrát vyplývajících z vašeho používání služby.
                </p>
                <p className="leading-relaxed">
                  Toto omezení odpovědnosti se nevztahuje na škody způsobené úmyslným jednáním nebo hrubou nedbalostí, nebo jak je jinak zakázáno platnými právními předpisy.
                </p>
                <p className="leading-relaxed">
                  Naše celková odpovědnost vůči vám za jakékoli nároky vyplývající z vašeho používání služby nepřesáhne částku, kterou jste nám zaplatili za 12 měsíců předcházejících nároku, nebo 2 500 Kč, podle toho, která částka je vyšší.
                </p>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">15. Ukončení</h2>
              <p className="leading-relaxed">
                Můžeme ukončit nebo pozastavit váš účet a zablokovat přístup ke službě okamžitě, bez předchozího upozornění nebo odpovědnosti, podle našeho výhradního uvážení, z jakéhokoli důvodu, včetně mimo jiné porušení Podmínek.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">16. Změny podmínek</h2>
              <p className="leading-relaxed">
                Vyhrazujeme si právo kdykoli tyto Podmínky upravit nebo nahradit. Pokud je revize podstatná, poskytneme alespoň 30 dnů předem oznámení před nabytím účinnosti nových podmínek.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">17. Kontaktní informace</h2>
              <div className="space-y-4">
                <p className="leading-relaxed">
                  Pokud máte nějaké otázky ohledně těchto Obchodních podmínek, kontaktujte nás:
                </p>

                <div className="bg-gray-50 p-4 rounded-lg">
                  <p className="text-sm text-gray-700">
                    <strong>E-mail:</strong> support@simplestickers.app
                  </p>
                  <p className="text-xs text-gray-500 mt-2">
                    Pro všechny dotazy týkající se podpory, právních záležitostí, ochrany soukromí, ochrany údajů a obchodních dotazů
                  </p>
                </div>
              </div>
            </section>
          </div>
        </article>
      </div>
    </div>
  );
}
